import React from 'react';
import './eventsFoundation.css';

// One header for every card on the Event page: title on the left, its button on the right, on the same baseline. Help sits under them.
export default function SectionHeader({ title, help = null, action = null, level = 3, id }) {
    const Tag = `h${level}`;
    return (
        <header className={`ef-section-header ef-section-header--${level}`} data-testid="section-header">
            <div className="ef-section-header__row">
                <Tag className="ef-section-header__title" id={id}>{title}</Tag>
                {action && <div className="ef-section-header__action">{action}</div>}
            </div>
            {help && <p className="ef-muted ef-small">{help}</p>}
        </header>
    );
}
